import React, { useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import icon_img from "../../images/logo.png";
import { fontSize } from "../../styles";
import { fetchResetPasswordLink } from "../../service/logic";
import { OpeningLayout, useWindowDimensions } from "../common";

const useStyles = makeStyles((theme) => ({
  logo: {
    width: "60%",
    [theme.breakpoints.down("sm")]: {
      width: "73%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "55%",
    },
  },
  paper: {
    height: "100vh",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "60%",
      padding: 30,
    },
    [theme.breakpoints.down("xs")]: {
      width: "77vw",
      padding: "50px 10px",
      alignItems: "flex-start",
    },
    padding: 50,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 1,
  },
  bgClinic: {
    width: "66%",
    position: "absolute",
    marginLeft: "50%",
    marginTop: "10%",
  },
  form: {
    width: "90%",
    color: "#1D3557",
  },
  inputfield: {
    color: "#1D3557",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: `0px solid white`,
      },
      "&.Mui-focused fieldset": {
        border: `0px solid white`,
      },
    },
  },
  input: {
    color: "#1D3557",
    "&:hover": {
      color: "#457B9D",
    },
  },
  placeholderColor: {
    "&::placeholder": {
      color: "black",
      fontWeight: "bold",
    },
  },
  buttonContainer: {
    textAlign: "center",
  },
  submit: {
    paddingLeft: 75,
    paddingRight: 75,
    backgroundColor: "#1D3557",
    borderRadius: 16,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fontSize: fontSize.h4,
    "&:hover": {
      backgroundColor: "#457B9D",
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 55,
      paddingRight: 55,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  links: {
    marginTop: 20,
    marginBottom: 20,
  },
  linktext: {
    color: "red",
    textDecoration: "underline",
  },
  errorStyle: {
    color: "red",
    marginBottom: 10,
  },
  imageHolder: {
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
    },
    display: "flex",
    width: "100%",
    justifyContent: "center",
    marginTop: 50,
    marginBottom: 50,
  },
  longText: {
    marginTop: 20,
  },
}));

export default function LoginScreen() {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const checkEmail = () => {
    if (!email.length) {
      setErrorMessage("Empty email");

      return false;
    }

    return true;
  };

  const onContinue = async (event) => {
    event.preventDefault();

    if (checkEmail()) {
      await fetchResetPasswordLink(email);
    }
  };

  const classes = useStyles();
  const { height, width } = useWindowDimensions();
  const isIpad = width / height === 768 / 1024;
  const isIpadPro = width / height === 1024 / 1366;

  return (
    <React.Fragment>
      <CssBaseline />
      <OpeningLayout
        content={
          <div
            className={classes.paper}
            style={{
              justifyContent: isIpadPro || isIpad ? "center" : "flex-start",
            }}
          >
            <div className={classes.imageHolder}>
              <img
                className={classes.logo}
                src={icon_img}
                alt={"Virtual Patient"}
              />
            </div>
            <form className={classes.form} noValidate>
              <Typography variant="h3" style={{ color: "black" }}>
                Forgot Your Password?
              </Typography>
              <Typography variant="h4" className={classes.longText}>
                Enter your email address and we will send you instructions to
                reset your password.
              </Typography>
              <TextField
                className={classes.inputfield}
                margin="normal"
                fullWidth
                id="email"
                placeholder="Email"
                name="email"
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                InputProps={{
                  className: classes.input,
                  classes: { input: classes.placeholderColor },
                }}
              />
              <Typography className={classes.errorStyle}>
                {errorMessage}
              </Typography>
              <div className={classes.buttonContainer}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={(e) => {
                    onContinue(e);
                  }}
                  style={{ textTransform: "none " }}
                >
                  Continue
                </Button>
              </div>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.links}
              >
                <Link href="/login">
                  <Typography className={classes.linktext}>
                    Back to Login
                  </Typography>
                </Link>
              </Grid>
            </form>
          </div>
        }
      />
    </React.Fragment>
  );
}
